<template>
  <div class="formGroup" :data-layout="layout">
    <input type="hidden" :name="name" :value="rawValue" v-validate:rawValue="validation">
    <input type="hidden" :name="unknownName" :value="Number(isUnknown)">

    <div class="formGroup__body">
      <formLabel :label="label"></formLabel>
      <div class="buttonGroup">
        <div class="buttonGroup__item" :data-active="!!isUnknown" @click="switchIsUnknown(true)">
          <span>不明</span>
        </div>
        <div
          class="buttonGroup__item"
          :data-active="!isUnknown"
          @click="switchIsUnknown(false, $event.target)"
        >
          <span v-show="isUnknown">入力する</span>

          <div v-show="!isUnknown" class="timeInput">
            <input
              class="formControl timehoge"
              data-size="small"
              :placeholder="placeholder"
              type="tel"
              :data-error="errors.has(name)"
              ref="input"
              @input="changeNext"
              @click="selectAll($event.target)"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="formGroup__footer">
      <p class="formGroup__errorMessage">{{ errors.first(name) }}</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'
import { BIRTHTIME_UNKNOWN_VALUE } from '@/CONSTS'

export default {
  name: 'form-birthtime',
  mixins: [mixin],
  data: () => ({
    $input: null,
    isUnknown: true,
    rawValue: ''
  }),

  props: {
    name: { type: String, required: true },
    unknownName: { type: String, required: true },
    value: Object
  },

  watch: {
    // 商品購入時に登録情報から出生時間を取得(遅れて取得されるためwatch処理)
    value() {
      if (this.value.value !== this.rawValue) {
        this.onMounted()
      }
    }
  },

  mounted() {
    this.onMounted()
  },

  methods: {
    onMounted() {
      this.$input = this.$refs.input
      if (this.value) {
        this.$input.value = typeof this.value.value === 'string' ? this.value.value : BIRTHTIME_UNKNOWN_VALUE
        this.rawValue = this.$input.value
      }
      this.addColon()
    },

    selectAll(target) {
      target.setSelectionRange(0, 7)
    },

    addColon() {
      const val = [this.$input.value.slice(0, 2), ' : ', this.$input.value.slice(2)]
      this.$input.value = val.reduce((total, add) => total + add)
    },

    /**
     * 出生時間不明か入力かの切り替え
     * @param {Booelan} flag
     */
    switchIsUnknown(flag, target) {
      this.isUnknown = flag
      if (flag) {
        this.$input.value = BIRTHTIME_UNKNOWN_VALUE
      } else if (this.rawValue === BIRTHTIME_UNKNOWN_VALUE) {
        this.$input.value = '0000'
        this.addColon()
        this.selectAll(target.nextElementSibling.children[0])
      }
      if (!flag && this.$input) {
        setTimeout(() => {
          this.$input.focus()
        }, 10)
      }
      this.update()
    },

    changeNext() {
      if (/^[0-9][0-9] \:$/.test(this.$input.value) || /^2[4-9]$/.test(this.$input.value)) this.$input.value = this.$input.value.substr(0, 1)
      else if (this.$input.value.length === 1 && this.$input.value.match(/[3-9]/)) this.zeropadding(this.$input.value)
      else {
        this.$input.value = this.$input.value.replace(/[^0-9]/g, '').substr(0, 4)
        if (this.$input.value.length === 3 && this.$input.value.match(/[0-9][0-9][6-9]/)) this.zeropadding(this.$input.value)
      }
      if (this.$input.value.length >= 2) this.addColon()
      this.update()
    },

    update() {
      this.rawValue = this.$input.value.replace(/[^0-9]/g, '')
      let newValue = {
        value: this.rawValue,
        unknown: Number(this.isUnknown)
      }
      this.$emit('input', newValue)
    },

    zeropadding(num) {
      if (num.length === 1) this.$input.value = '0' + num
      if (num.length === 3) this.$input.value = [this.$input.value.slice(0, 2), '0', this.$input.value.slice(2)].reduce((total, add) => total + add)
    },
  }
}
</script>

<style lang="scss" scoped>
.buttonGroup {
  display: flex;
  height: 36px;
  &__item {
    min-width: 72px;
    border: 1px solid;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #000000;
    background: rgba(248, 248, 248, 0.9);
    cursor: pointer;
    color: #000000;
    &:first-child {
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-radius: 0 4px 4px 0;
    }
    &[data-active='true'] {
      background: #000000;
      border-color: #000000;
      color: #fff;
      font-weight: bold;
    }
  }
}
.timeInput {
  display: inline-flex;
  align-items: center;
  color: #fff;
  .formControl {
    width: 80px;
    background: #fff;
  }
  > span {
    margin: 0 0.5em;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormBirthtime.vue